var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"sk-btn sk-btn--white system-log-btn lock-job-btn",on:{"click":_vm.lockJob}},[_vm._v("\n  "+_vm._s(_vm.$gettext('Lock Job'))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }